import React from "react";
import { reviews } from "../mock";
import { Star, Quote } from "lucide-react";

const Reviews = () => {
  return (
    <section id="reviews" className="py-24 bg-brand-dark relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, #F5B12D 1px, transparent 1px), radial-gradient(circle at 70% 70%, #F5B12D 1px, transparent 1px)",
            backgroundSize: "40px 40px",
          }}
        />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="text-brand-yellow text-sm font-bold tracking-[0.3em] mb-3">
            CLIENT REVIEWS
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
            WHAT OUR CUSTOMERS SAY
          </h2>
          <div className="w-16 h-1 bg-brand-yellow mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((r) => (
            <div
              key={r.id}
              className="bg-brand-dark-2 border border-white/5 rounded-lg p-7 hover:border-brand-yellow/40 transition-all duration-300 group relative"
            >
              <Quote
                className="absolute top-6 right-6 text-brand-yellow/10 group-hover:text-brand-yellow/20 transition-colors"
                size={48}
              />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star
                    key={i}
                    className="text-brand-yellow fill-brand-yellow"
                    size={16}
                  />
                ))}
              </div>
              <p className="text-gray-300 text-sm leading-relaxed mb-6 relative z-10">
                “{r.text}”
              </p>
              <div className="pt-4 border-t border-white/10">
                <div className="font-display text-white text-base tracking-wide">
                  {r.name}
                </div>
                <div className="text-brand-yellow text-xs font-semibold tracking-wider mt-0.5">
                  {r.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
